module.exports = __webpack_public_path__ + "img/operationCapacity7.4cfeda4f.png";